module.exports = {"alarmBox":"알림함","viewDetails":"자세히 보기","noAlarms":"수신된 알림이 없습니다.","answerNoticeLine1":"답변을 등록하면 문의자에게","answerNoticeLine2":"알림이 발송됩니다.","answerConfirm":"이대로 등록하시겠습니까?"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/al001.json
// module id = z6Mf
// module chunks = 2